module.exports = __webpack_public_path__ + "img/64.25e291f8.jpg";